module.exports = __webpack_public_path__ + "img/webzuliapack.4d4737cc.svg";